export const DEMO_SPACE_THEME_CONTENT_URL = `https://app.storyblok.com/v1/cdn/stories/onboarding/demo-themes?`
export const DEFAULT_DEMO_SPACE_ID = 329757
export const DEMO_SPACE_TOUR_HINTS_CONTENT_URL = `https://app.storyblok.com/v1/cdn/stories/onboarding/demo-space-tour-hints?`
